<template> 
    <modal :ref="`printModal${_uid}`" :modalWidth="`${modalWidth}`" :title="modalTitle">
        <template #body>
            <button class="btn btn-link btn-sm" style="float:right" @click="print"><i class="fas fa-print"></i></button>
            <div v-html="content"></div>
        </template>
    </modal>
</template>

<script>
import modal from "../modal/index";
export default {
    /**
        tag
        name: ks-print-modal
        description: print modal
    **/
    name: 'ks-print-modal',
    components: {modal},
    props:{
        /**
            attribute
            name: content 
            description: content
        **/
        content:{
            type:String,
            required: true
        },
        /**
            attribute
            name: modalTitle 
            description: modalTitle
        **/
        modalTitle:{
            type: String,
            default: null
        },
        /**
            attribute
            name: modalWidth 
            description: modalWidth
        **/
        modalWidth:{
            type: Number,
            default:75
        },
        /**
            attribute
            name: height 
            description: height
        **/
        height :{
            type:Number,
            default:600
        },
        /**
            attribute
            name: width 
            description: width
        **/
        width :{
            type:Number,
            default:800
        }
    },
    methods:{
        print(){
            var printWindow = window.open('', 'PRINT', `height=${this.height},width=${this.width}`);
            printWindow.document.write('</head><body >');
            printWindow.document.write(this.content);
            printWindow.document.write('</body></html>');
            printWindow.document.close();
            printWindow.focus();
            printWindow.print();
            printWindow.close();
            return true;
        },
        open(){
            this.$refs[`printModal${this._uid}`].show();
        },
        close(){
            this.$refs[`printModal${this._uid}`].hide();
        } 
    }
}
</script>
